var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128,296l-.27-46.89C57.18,249.11,0,193.34,0,124.55S57.18,0,127.71,0,256,55.76,256,124.55C256,209,193.59,258.75,128,296Zm79.18-167.95V81.66L173.5,115.23V93.82A16.48,16.48,0,0,0,157.06,77.4H72A16.48,16.48,0,0,0,55.59,93.82v68.45A16.49,16.49,0,0,0,72,178.7h85a16.49,16.49,0,0,0,16.44-16.43V140.66l33.66,33.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4fdfeb8283eb28c4ba9c5c7d33c37011.svg";
export { ForwardRef as ReactComponent };